<template>
  <section>
    <NavText text="Customer" class="pl-2" />

    <div v-for="(navItem, index) in navLink" :key="index" class="">
      <!-- no dropdown -->

      <section v-if="customerNav(navItem)">
        <NoDropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>

      <!-- dropdown -->
      <section v-if="customerNav(navItem)">
        <DropdownNav :navItem="navItem" :getNavIcon="getNavIcon" />
      </section>

      <!--  -->
    </div>
  </section>
</template>

<script>
//components

import NavText from "../Text/NavText.vue";
import DropdownNav from "@/components/UI/AutomatedSidebar/DropdownNav.vue";
import NoDropdownNav from "@/components/UI/AutomatedSidebar/NoDropdownNav.vue";

export default {
  name: "CustomerNavs",
  props: ["navLink", "getNavIcon", "modules"],
  components: {
    NavText,
    DropdownNav,
    NoDropdownNav,
  },
  methods: {
    //utilities
    customerNav(navItems) {
      const nav = navItems?.name?.toLowerCase();

      if (
        (nav === "card management" &&
          this.modules?.includes("card management")) ||
        (nav === "dry stock order" &&
          this.modules?.includes("dry stock order")) ||
        (nav === "stock inventory" && this.modules?.includes("stock inventory"))
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
